<template>
  <div>
    <l-tile-layer
      v-if="selectedBaseTile"
      :url="selectedBaseTile.url"
      :options="{
        maxNativeZoom: maxNativeZoom,
        updateWhenIdle: false,
        zIndex: 1
      }"
      :attribution="attribution"
    />
    <l-tile-layer
      v-if="isHillTile"
      url="https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png"
      :options="{
        maxNativeZoom: maxNativeZoom,
        updateWhenIdle: false,
        opacity: 0.6,
        zIndex: 2
      }"
    />
  </div>
</template>

<script>
import { LTileLayer } from "vue2-leaflet";
import { BaseTile } from "../../../enums/BaseTile";

export default {
  name: "BaseTileLayer",
  components: {
    LTileLayer
  },
  data() {
    return {
      BaseTile,
      attribution:
        "<a href='https://maps.gsi.go.jp/development/ichiran.html'>地理院タイル</a>"
    };
  },
  computed: {
    map() {
      return this.$store.getters.leafletMap;
    },
    selectedBaseTile() {
      return this.$store.getters.selectedBaseTile;
    },
    maxNativeZoom() {
      switch (this.selectedBaseTile) {
        case BaseTile.WHITE:
          return 14;
        default:
          return 18;
      }
    },
    isHillTile() {
      return this.selectedBaseTile.key === BaseTile.HILL.key;
    }
  }
};
</script>
